import { useMutation } from "@tanstack/react-query";
import { deleteMarketplaceSaved } from "PFCore/services/marketplace/delete_marketplace_saved";
import { Id } from "PFTypes";
import { MutationOptions } from "PFTypes/request_options";

type MarketplaceDeleteSavedParams = { id: Id };

export const useSavedDelete = (options: MutationOptions<MarketplaceDeleteSavedParams> = {}) =>
  useMutation({
    mutationFn: (payload: MarketplaceDeleteSavedParams) => deleteMarketplaceSaved(payload.id),
    ...options
  });
